export const colorPrimary: string = "#3BAA90";
export const colorGreyOverlay: string = "#323B4B80";
export const colorNavy: string = "#344054";
